// extracted by mini-css-extract-plugin
export default {"card":"Card_card__0w5CF","card_header":"Card_card_header__mEVjm","title":"Card_title__lh6MD"};